<template>
  <v-btn
    block
    color="success darken-2"
    type="submit"
    :disabled="disabled"
    :loading="loading"
    @click="$emit('nextClick')"
  >
    {{ title }}
  </v-btn>
</template>

<script>
export default {
  name: 'BtnNext',
  props: {
    title: {
      type: String,
      default: 'Next'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }

}
</script>

<style>
</style>
